import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function DefaultValue() {
  const location = useLocation();
  const pathname = location.pathname;
  const avatarName = pathname.split("/").pop().toLowerCase();

  const capitalizedAvatar =
    avatarName.charAt(0).toUpperCase() + avatarName.slice(1);

  useEffect(() => {
    sessionStorage.clear();
    if (
      !sessionStorage.getItem("AvatarName") &&
      !sessionStorage.getItem("id")
    ) {
      sessionStorage.setItem("AvatarName", capitalizedAvatar);

      switch (avatarName) {
        case "jason":
          sessionStorage.setItem("id", "3");
          break;
        case "emily":
          sessionStorage.setItem("id", "1");
          break;
        case "sri":
          sessionStorage.setItem("id", "1");
          break;
        case "jonathan":
          sessionStorage.setItem("id", "3");
          break;
        default:
          break;
      }
    }
  }, [avatarName, capitalizedAvatar]);

  return null;
}

export default DefaultValue;
